import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaHome, FaInfoCircle, FaConciergeBell, FaCog, FaImages, FaPhoneAlt, FaPhone, FaBars, FaTimes, FaChevronDown, FaBullhorn, FaLink, FaEllipsisH, FaEnvelope, FaFacebookF, FaTwitter, FaInstagram, FaYoutube, FaMapMarkerAlt, FaMobileAlt, FaGlobe, FaArrowRight, FaLeaf, FaHandshake, FaShieldAlt, FaUsers, FaClock, FaPhotoVideo, FaFileAlt, FaMap } from 'react-icons/fa';
import { translations } from './i18n';
import './App.css';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Schemes from './pages/Schemes';
import Gallery from './pages/Gallery';
import Contact from './pages/Contact';
import VillageMap from './pages/VillageMap';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import ImportantLinks from './pages/ImportantLinks';
import CitizenServices from './pages/CitizenServices';
import Announcements from './pages/Announcements';

function App() {
  const [language] = useState('mr');
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState({});
  const t = translations[language];

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.nav-dropdown')) {
        setDropdownOpen({});
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  // Fix Google Translate body shift — disabled for now
  /* useEffect(() => {
    const fixGoogleTranslate = () => {
      if (document.body.style.top && document.body.style.top !== '0px') {
        document.body.style.top = '0px';
      }
    };

    const observer = new MutationObserver(fixGoogleTranslate);
    observer.observe(document.body, { attributes: true, attributeFilter: ['style'] });

    const hideGTBanner = () => {
      const banner = document.querySelector('.goog-te-banner-frame');
      if (banner) {
        banner.style.display = 'none';
        document.body.style.top = '0px';
      }
    };
    const bannerObserver = new MutationObserver(hideGTBanner);
    bannerObserver.observe(document.body, { childList: true, subtree: true });

    return () => {
      observer.disconnect();
      bannerObserver.disconnect();
    };
  }, []); */

  const toggleDropdown = (menu) => {
    setDropdownOpen(prev => {
      const isOpen = prev[menu];
      return { [menu]: !isOpen };
    });
  };

  return (
    <Router>
      <div className="App">
        {/* Sticky Header Wrapper */}
        <div className="sticky-header">
        {/* Top Header */}
        <div className="top-header">
          <div className="top-header-inner">
            <div className="contact-info">
              <span><FaEnvelope /> gpnasherapsmokhada@gmail.com | <FaPhone /> +91 7620 135 257</span>
            </div>
            <div className="service-motto">
              <FaLeaf className="motto-icon" />
              <span>अखंड सेवा, सक्षम नागरिक</span>
            </div>
            <div className="header-right">
              {/* Google Translate — disabled for now */}
              {/* <div id="google_translate_element"></div> */}
            </div>
          </div>
        </div>

        {/* Main Header */}
        <div className="main-header">
          <div className="container">
            <div className="header-content">
              <Link to="/" className="main-logo">
                <img src="/img/logo1.png" alt="Gram Panchayat Logo" className="logo-img" />
                <div className="logo-text">
                  <h1>ग्राम पंचायत नाशेरा</h1>
                  <p>तालुका: मोखाडा | जिल्हा: पालघर</p>
                </div>
              </Link>
              
              {/* Desktop Navigation */}
              <div className="desktop-nav">
                <div className={`nav-links ${menuOpen ? 'active' : ''}`}>
                  <Link to="/" onClick={() => setMenuOpen(false)}>
                    <FaHome /> {t.home}
                  </Link>
                  
                  <div className="nav-dropdown">
                    <button 
                      className="nav-dropdown-btn"
                      onClick={() => toggleDropdown('about')}
                    >
                      <FaInfoCircle /> {t.about} <FaChevronDown />
                    </button>
                    {dropdownOpen.about && (
                      <div className="dropdown-menu">
                        <Link to="/about" onClick={() => setDropdownOpen({})}><FaFileAlt /> {t.introduction}</Link>
                        <Link to="/about" onClick={() => setDropdownOpen({})}><FaUsers /> {t.keyOfficials}</Link>
                      </div>
                    )}
                  </div>

                  <div className="nav-dropdown">
                    <button 
                      className="nav-dropdown-btn"
                      onClick={() => toggleDropdown('announcements')}
                    >
                      <FaBullhorn /> {t.announcements} <FaChevronDown />
                    </button>
                    {dropdownOpen.announcements && (
                      <div className="dropdown-menu">
                        <Link to="/announcements" onClick={() => setDropdownOpen({})}><FaBullhorn /> कर भरणा सूचना</Link>
                        <Link to="/announcements" onClick={() => setDropdownOpen({})}><FaBullhorn /> ग्रामसभा सूचना</Link>
                        <Link to="/announcements" onClick={() => setDropdownOpen({})}><FaBullhorn /> नवीन योजना</Link>
                      </div>
                    )}
                  </div>

                  <div className="nav-dropdown">
                    <button 
                      className="nav-dropdown-btn"
                      onClick={() => toggleDropdown('links')}
                    >
                      <FaLink /> {t.importantLinks} <FaChevronDown />
                    </button>
                    {dropdownOpen.links && (
                      <div className="dropdown-menu">
                        <Link to="/important-links" onClick={() => setDropdownOpen({})}><FaGlobe /> शासकीय पोर्टल्स</Link>
                        <Link to="/important-links" onClick={() => setDropdownOpen({})}><FaFileAlt /> ऑनलाइन सेवा</Link>
                      </div>
                    )}
                  </div>

                  <Link to="/services" onClick={() => setMenuOpen(false)}>
                    <FaCog /> {t.services}
                  </Link>

                  <Link to="/gallery" onClick={() => setMenuOpen(false)}>
                    <FaPhotoVideo /> {t.gallery}
                  </Link>

                  <Link to="/contact" onClick={() => setMenuOpen(false)}>
                    <FaPhoneAlt /> {t.contact}
                  </Link>

                  <div className="nav-dropdown">
                    <button 
                      className="nav-dropdown-btn"
                      onClick={() => toggleDropdown('more')}
                    >
                      <FaEllipsisH /> {t.more} <FaChevronDown />
                    </button>
                    {dropdownOpen.more && (
                      <div className="dropdown-menu">
                        <Link to="/village-map" onClick={() => setDropdownOpen({})}><FaMap /> {t.villageMap}</Link>
                        <Link to="/schemes" onClick={() => setDropdownOpen({})}><FaFileAlt /> शासकीय योजना</Link>
                        <Link to="/important-links" onClick={() => setDropdownOpen({})}><FaLink /> महत्त्वाचे दुवे</Link>
                      </div>
                    )}
                  </div>
                </div>

                <div className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
                  {menuOpen ? <FaTimes /> : <FaBars />}
                </div>
              </div>

              {/* Right logo */}
              <img src="/img/logo3.png" alt="Logo" className="header-right-logo" />
            </div>
          </div>
        </div>
        </div>{/* end sticky-header */}

        {/* Marquee Section */}
        <div className="marquee-section">
          <div className="marquee-content">
            <span>📢 सूचना: नागरिकांना आव्हान आहे की कर भरणा वेळेवर करा व आपल्या ग्रामपंचायतला सहकार्य करा - कर भरण्यासाठी कार्यालयाशी संपर्क साधा... &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 📢 सूचना: ग्रामपंचायत नाशेरा येथे नवीन विकास कामे सुरू आहेत, अधिक माहितीसाठी कार्यालयाशी संपर्क साधा... &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 📢 सूचना: ग्रामसभेची बैठक लवकरच होणार आहे, सर्व नागरिकांनी उपस्थित राहावे...</span>
          </div>
        </div>

        {/* Navigation */}
        <motion.nav 
          className="navbar"
          initial={{ y: -100 }}
          animate={{ y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <div className="container">
            <div className="nav-content">
              {/* Mobile Navigation will be handled by the header */}
            </div>
          </div>
        </motion.nav>

        {/* Routes */}
        <Routes>
          <Route path="/" element={<Home language={language} />} />
          <Route path="/about" element={<About language={language} />} />
          <Route path="/services" element={<Services language={language} />} />
          <Route path="/schemes" element={<Schemes language={language} />} />
          <Route path="/citizen-services" element={<CitizenServices language={language} />} />
          <Route path="/gallery" element={<Gallery language={language} />} />
          <Route path="/contact" element={<Contact language={language} />} />
          <Route path="/village-map" element={<VillageMap language={language} />} />
          <Route path="/important-links" element={<ImportantLinks language={language} />} />
          <Route path="/announcements" element={<Announcements />} />
          <Route path="/terms" element={<Terms language={language} />} />
          <Route path="/privacy" element={<Privacy language={language} />} />
        </Routes>

        {/* Footer */}
        <footer className="footer">
          {/* Footer Top Wave */}
          <div className="footer-wave">
            <svg viewBox="0 0 1440 60" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0,30 C360,60 1080,0 1440,30 L1440,0 L0,0 Z" fill="#f8f9fa"/>
            </svg>
          </div>

          {/* Footer Brand Strip */}
          <div className="footer-brand-strip">
            <motion.div
              className="footer-brand"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7 }}
              viewport={{ once: true }}
            >
              <div className="footer-logo-wrap">
                <img src="/img/logo1.png" alt="GP Nashera" style={{ height: '60px' }} />
                <div>
                  <h2 className="footer-brand-title">ग्राम पंचायत नाशेरा</h2>
                  <p className="footer-brand-sub">तालुका: मोखाडा | जिल्हा: पालघर</p>
                </div>
              </div>
              <div className="footer-tagline">
                <FaLeaf className="footer-tagline-icon" />
                <span>अखंड सेवा, सक्षम नागरिक</span>
              </div>
            </motion.div>
          </div>

          <div className="container">
            <div className="footer-content">

              {/* Col 1: Quick Links */}
              <motion.div
                className="footer-section"
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.1 }}
                viewport={{ once: true }}
              >
                <h3 className="footer-heading">
                  <FaLink className="footer-heading-icon" /> उपयुक्त दुवे
                </h3>
                <div className="footer-divider" />
                <div className="footer-links">
                  <Link to="/"><FaArrowRight className="footer-link-icon" /> मुख्यपृष्ठ</Link>
                  <Link to="/about"><FaArrowRight className="footer-link-icon" /> आमच्याबद्दल</Link>
                  <Link to="/services"><FaArrowRight className="footer-link-icon" /> सेवा</Link>
                  <Link to="/schemes"><FaArrowRight className="footer-link-icon" /> योजना</Link>
                  <Link to="/gallery"><FaArrowRight className="footer-link-icon" /> गॅलरी</Link>
                  <Link to="/important-links"><FaArrowRight className="footer-link-icon" /> महत्त्वाचे दुवे</Link>
                  <Link to="/contact"><FaArrowRight className="footer-link-icon" /> संपर्क</Link>
                </div>
              </motion.div>

              {/* Col 2: Contact */}
              <motion.div
                className="footer-section"
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                viewport={{ once: true }}
              >
                <h3 className="footer-heading">
                  <FaPhone className="footer-heading-icon" /> संपर्क माहिती
                </h3>
                <div className="footer-divider" />
                <div className="footer-contact-list">
                  <div className="footer-contact-item">
                    <span className="footer-contact-icon"><FaMapMarkerAlt /></span>
                    <span>ग्राम पंचायत नाशेरा,<br />तालुका: मोखाडा | जिल्हा: पालघर,<br />महाराष्ट्र - ४०१६०४</span>
                  </div>
                  <div className="footer-contact-item">
                    <span className="footer-contact-icon"><FaMobileAlt /></span>
                    <a href="tel:+917620135257">+91 7620 135 257</a>
                  </div>
                  <div className="footer-contact-item">
                    <span className="footer-contact-icon"><FaEnvelope /></span>
                    <a href="mailto:gpnasherapsmokhada@gmail.com">gpnasherapsmokhada@gmail.com</a>
                  </div>
                  <div className="footer-contact-item">
                    <span className="footer-contact-icon"><FaClock /></span>
                    <span>सोमवार - शनिवार: सकाळी ९ - संध्याकाळी ५</span>
                  </div>
                </div>
              </motion.div>

              {/* Col 3: Social + Values */}
              <motion.div
                className="footer-section"
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.3 }}
                viewport={{ once: true }}
              >
                <h3 className="footer-heading">
                  <FaUsers className="footer-heading-icon" /> आमच्याशी जोडा
                </h3>
                <div className="footer-divider" />
                <div className="social-links">
                  <a href="#" className="social-link facebook" aria-label="Facebook"><FaFacebookF /></a>
                  <a href="#" className="social-link twitter" aria-label="Twitter"><FaTwitter /></a>
                  <a href="#" className="social-link instagram" aria-label="Instagram"><FaInstagram /></a>
                  <a href="#" className="social-link youtube" aria-label="YouTube"><FaYoutube /></a>
                </div>
                <div className="footer-values">
                  <div className="footer-value-item">
                    <FaHandshake className="fv-icon" />
                    <span>पारदर्शकता</span>
                  </div>
                  <div className="footer-value-item">
                    <FaShieldAlt className="fv-icon" />
                    <span>जबाबदारी</span>
                  </div>
                  <div className="footer-value-item">
                    <FaLeaf className="fv-icon" />
                    <span>विकास</span>
                  </div>
                  <div className="footer-value-item">
                    <FaUsers className="fv-icon" />
                    <span>सहभाग</span>
                  </div>
                </div>
              </motion.div>

              {/* Col 4: Map */}
              <motion.div
                className="footer-section"
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.4 }}
                viewport={{ once: true }}
              >
                <h3 className="footer-heading">
                  <FaMapMarkerAlt className="footer-heading-icon" /> आमचे स्थान
                </h3>
                <div className="footer-divider" />
                <div className="footer-map-wrap">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d235.89234567890123!2d73.421066!3d19.8132192!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be763defc5360ad%3A0x7607ceee27f25891!2sNashera%20Grampanchayat%20Office!5e0!3m2!1sen!2sin!4v1647123456789!5m2!1sen!2sin"
                    width="100%"
                    height="160"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Nashera Location"
                  ></iframe>
                </div>
              </motion.div>

            </div>

            <motion.div
              className="footer-bottom"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 0.8, delay: 0.5 }}
              viewport={{ once: true }}
            >
              <div className="footer-bottom-links">
                <Link to="/terms">अटी व शर्ती</Link>
                <span className="footer-dot">•</span>
                <Link to="/privacy">गोपनीयता धोरण</Link>
                <span className="footer-dot">•</span>
                <Link to="/contact">संपर्क</Link>
              </div>
              <p>&copy; 2025 ग्राम पंचायत नाशेरा. सर्व हक्क राखीव.</p>
              <p className="footer-dev">Developed by PARAM ELECTROINFO Nashik</p>
            </motion.div>
          </div>
        </footer>

        {/* WhatsApp Widget */}
        <div className="whatsapp-widget">
          <a 
            href="https://wa.me/917620135257?text=Welcome%20to%20Nashera%20Gram%20Panchayat!%20How%20can%20we%20help%20you%3F"
            target="_blank"
            rel="noopener noreferrer"
            className="whatsapp-button"
            title="Chat with us on WhatsApp"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.89 3.488"/>
            </svg>
          </a>
        </div>
      </div>
    </Router>
  );
}

export default App;
